import { render, staticRenderFns } from "./ManagerCloseTillSlip.template.vue?vue&type=template&id=47ac670c&scoped=true&"
var script = {}
import style0 from "./ManagerCloseTillSlip.template.vue?vue&type=style&index=0&id=47ac670c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac670c",
  null
  
)

export default component.exports